module.exports = "/assets/logo_sg_substance_painter-54accaaaff029949e8cbfa0564f5ecd6.png";